import { QueueTickets } from './queue-tickets';
import React from 'react';
import { QueueHeader } from './queue-header';
import { Queue } from '../../../types/queue';
import styled from 'styled-components';
import { sizes } from '../../../themes/sizes';

const Container = styled.section`
  display: grid;
  height: 100%;
  overflow-y: hidden;
  grid-template-rows: auto 1fr;
  gap: ${sizes.margins.large};
`;
const TicketList = styled.section`
  height: 100%;
  overflow-y: auto;
`;

export interface TicketLaneProps {
  queue: Queue;
  onAppendTicket: (ticketNote: string) => void;
}

export function TicketLane(props: TicketLaneProps) {
  const { queue, onAppendTicket } = props;
  return (
    <Container>
      <QueueHeader onAppendTicket={onAppendTicket} queue={queue} />
      <TicketList>
        <QueueTickets queueId={queue.id} tickets={queue.tickets} />
      </TicketList>
    </Container>
  );
}
